"use client";

import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

interface KeyBiscayneHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function KeyBiscayneHero({ h1, subhead, zips }: KeyBiscayneHeroProps) {
  const { t, currentLang } = useLanguage();
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <section className="relative h-[80vh] flex items-end justify-center overflow-hidden">
      {/* Background image */}
      {!imgFailed && (
        <img
          src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/d2512ed8-9ae6-4e11-951e-556d6756cea3_Slide.1-2.jpg?v=3a336af2749701de4c5a703bbd40c036"
          alt={currentLang === "es" ? "Reparaci\u00F3n de ventanas en Key Biscayne Miami" : "Window repair in Key Biscayne Miami"}
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setImgFailed(true)}
        />
      )}
      {imgFailed && (
        <div className="absolute inset-0 bg-[#064e3b]" />
      )}
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#064e3b]/30" />

      {/* Content at bottom */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 pb-16 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-white/70 mb-4 font-light italic">
          {currentLang === "es" ? "REPARACI\u00D3N DE VENTANAS KEY BISCAYNE" : "KEY BISCAYNE WINDOW REPAIR"}
        </p>
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
          {h1 || t("keyBiscayne.h1")}
        </h1>
        <p className="max-w-2xl mx-auto text-white/90 text-lg mb-8 leading-relaxed">
          {subhead || t("keyBiscayne.subhead")}
        </p>
        {zips && zips.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
            {zips.map((zip) => (
              <span key={zip} className="inline-flex items-center gap-1.5 bg-white/15 backdrop-blur-sm text-white px-3 py-1.5 text-xs font-bold rounded-full border border-white/20">
                <i className="ri-map-pin-line" />
                {zip}
              </span>
            ))}
          </div>
        )}
        <a
          href="tel:+17863774452"
          className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-3 text-sm font-bold rounded-md hover:bg-[#c2410c] transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line" />
          {currentLang === "es" ? "Llame al (786) 377-4452" : "Call (786) 377-4452"}
        </a>
      </div>
    </section>
  );
}